export default function GoogleReviews() {
  // Avaliações do Google Meu Negócio
  // TODO: Integrar com Google Places API para buscar automaticamente
  // Place ID da GIO Estética Avançada de Paulínia: [INSERIR PLACE ID AQUI]
  
  const allReviews = [
    {
      name: 'Erika Ribeiro',
      rating: 5,
      date: 'Há 2 semanas',
      dateOrder: 1, // Mais recente = menor número
      text: 'Fui muito bem atendida na clínica! Ambiente limpo, organizado e profissionais extremamente atenciosos. Explicaram todo o procedimento com muito cuidado e me senti muito segura. O resultado ficou ótimo. Recomendo muito!',
      photoUrl: 'https://lh3.googleusercontent.com/a/default-user=s40-c'
    },
    {
      name: 'Natália Franco',
      rating: 5,
      date: 'Há 3 semanas',
      dateOrder: 2,
      text: 'Equipe nota mil, as meninas são super atenciosas. Quero agradecer em especial a Lili que me acompanhou durante o tratamento, enquanto ficamos mais bonitas, damos várias risadas.',
      photoUrl: 'https://lh3.googleusercontent.com/a/default-user=s40-c'
    },
    {
      name: 'Daniella Helmeister Faliveni',
      rating: 5,
      date: 'Há 3 semanas',
      dateOrder: 3,
      text: 'Tive excelentes resultados logo na primeira sessão!! Atendimento impecável desde o primeiro instante, tanto na recepção, como na apresentação da clínica e dos pacotes. E também durante as sessões. Toda equipe muito competente, atenciosa e respeitosa. Pode ir sem medo! Vale muito a pena conhecer.',
      photoUrl: 'https://lh3.googleusercontent.com/a/default-user=s40-c'
    },
    {
      name: 'Dayani Silva',
      rating: 5,
      date: 'Há 3 semanas',
      dateOrder: 4,
      text: 'Quero agradecer a equipe GIOlaser! Desde o primeiro atendimento fui muito bem recebida, já há alguns anos, rsrs... com profissionais atenciosos, cuidadosos e extremamente capacitados. A avaliação ...',
      photoUrl: 'https://lh3.googleusercontent.com/a/default-user=s40-c'
    }
  ];

  // Filtrar apenas avaliações 5 estrelas e ordenar por mais recentes
  const reviews = allReviews
    .filter(review => review.rating === 5)
    .sort((a, b) => a.dateOrder - b.dateOrder);

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <i className="ri-google-fill text-4xl text-[#4285F4]"></i>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black">
              Avaliações do Google
            </h2>
          </div>
          <p className="text-lg text-gray-600">
            Veja o que nossos clientes dizem sobre a GIO Estética Avançada de Paulínia
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow"
            >
              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h4 className="font-bold text-gray-900">{review.name}</h4>
                  <p className="text-sm text-gray-500">{review.date}</p>
                </div>
                <i className="ri-google-fill text-2xl text-[#4285F4]"></i>
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-700 leading-relaxed">
                {review.text}
              </p>
            </div>
          ))}
        </div>

        {/* Link para ver todas as avaliações */}
        <div className="text-center">
          <a
            href="https://share.google/4uRQ33KklTivbftm1"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#4285F4] hover:bg-[#3367D6] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-lg"
          >
            <i className="ri-google-fill text-xl"></i>
            Ver todas as avaliações no Google
          </a>
        </div>
      </div>
    </section>
  );
}
